import axios from "../../privateApi";

export const markSbcSetAsFavorite = (setId: number, isFavorite: boolean) =>
  axios.post("/favorite-sbc-set", { setId, isFavorite });
